/**
 * What 3 Ingredients - Regional Detection Utility
 * Auto-detects user region using browser timezone & locale indicators,
 * allowing instant local dish suggestions.
 */

const REGION_MAP = {
  'north-america': 'North America',
  'mediterranean': 'Mediterranean',
  'east-asia': 'East Asia',
  'latin-america': 'Latin America',
  'south-asia': 'South Asia',
  'europe': 'Europe',
  'all': 'Global (All Regions)'
};

/**
 * Auto-detects region based on system timezone
 * @returns {string} region code
 */
export function detectUserRegion() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const tzLower = tz.toLowerCase();

    if (tzLower.includes('america/new_york') || tzLower.includes('america/chicago') || 
        tzLower.includes('america/los_angeles') || tzLower.includes('america/toronto') ||
        tzLower.includes('america/vancouver') || tzLower.includes('america/denver')) {
      return 'north-america';
    }

    if (tzLower.includes('america/mexico') || tzLower.includes('america/bogota') || 
        tzLower.includes('america/santiago') || tzLower.includes('america/buenos_aires') ||
        tzLower.includes('america/sao_paulo')) {
      return 'latin-america';
    }

    if (tzLower.includes('asia/tokyo') || tzLower.includes('asia/shanghai') || 
        tzLower.includes('asia/seoul') || tzLower.includes('asia/hong_kong') ||
        tzLower.includes('asia/taipei')) {
      return 'east-asia';
    }

    if (tzLower.includes('asia/kolkata') || tzLower.includes('asia/dhaka') || 
        tzLower.includes('asia/karachi') || tzLower.includes('asia/colombo')) {
      return 'south-asia';
    }

    if (tzLower.includes('europe/athens') || tzLower.includes('europe/rome') || 
        tzLower.includes('europe/madrid') || tzLower.includes('asia/beirut') ||
        tzLower.includes('africa/cairo')) {
      return 'mediterranean';
    }

    if (tzLower.includes('europe/')) {
      return 'europe';
    }

  } catch (e) {
    console.warn('Timezone detection fallback used', e);
  }

  // Default region
  return 'north-america';
}

export function getRegionName(code) {
  return REGION_MAP[code] || 'Global';
}
